var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-file"},[_c('input',_vm._g(_vm._b({staticClass:"custom-file-input",attrs:{"type":"file","id":"customFileLang","lang":"fr"}},'input',_vm.$attrs,false),_vm.listeners)),_c('label',{staticClass:"custom-file-label",attrs:{"for":"customFileLang"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }